import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import indian from '../img/indian.png';
import american from '../img/flag.png';
import aus from '../img/aus_flag.png';

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [description, setDescription] = useState('');
  const [callTime, setCallTime] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetFields = () => {
    setName('');
    setEmail('');
    setPhone('');
    setDescription('');
    setCallTime('');
  };

  const validateFields = () => {
    if (!name || !email || !phone || !description || !callTime) {
      alert('All fields are mandatory');
      return false;
    }
    return true;
  };

  const submitHandler = async () => {
    if (!validateFields()) return;

    setIsSubmitting(true);
    try {
      const body = { name, email, phone, description, callTime };

      const response = await fetch('https://jdts.kvrwears.com/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      alert('Email sent Successfully');
      resetFields();
      await databaseManager(body);
    } catch (error) {
      alert('Please enter a registered email or check your input');
    } finally {
      setIsSubmitting(false);
    }
  };

  const databaseManager = async (body) => {
    try {
      const response = await fetch('https://jdtechnicalsolution.com/form/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Failed to send data to database');
      }

      console.log("Data sent successfully");
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  return (
    <div className="container-fluid contact bg-light py-5">
      <div className="container py-5">
        <div className="mx-auto text-center mb-5" style={{ maxWidth: "900px" }}>
          <span className="fw-bolder section-title px-3">CRUSH YOUR COMPETITION NOW</span>
          <p className="mb-0 fs-md-1 fs-5 fw-bolder" style={{ color: 'rgb(0,0,0)' }}>Contact For Any Query</p>
        </div>
        <div className="row g-5 align-items-center">
          <div className="col-lg-4">
            <div className="bg-white rounded p-4">
              {/* Contact Info Section */}
              <div className="text-center mb-4">
                <i className="fa fa-map-marker-alt fa-3x" style={{ color: 'rgb(15, 195, 250)' }}></i>
                <h4 className="text-dark">Address</h4>
                <p className="mb-0 text-secondary">B1, Soilder Tower, Commercial Complex <br /> New Delhi, 110018</p>
                <p className="mb-0 text-secondary">Level 13, Suite 1302/109 Pitt St,  <br /> Sydney NSW 2000 ,Australia</p>
              </div>
              <div className="text-center mb-4">
                <i className="fa fa-phone-alt fa-3x mb-3" style={{ color: 'rgb(15, 195, 250)' }}></i>
                <h4 className="text-dark">Mobile</h4>
                <img className="flags" src={indian} alt="" /> <Link to="tel:+919971979794" className="mb-0 text-secondary" style={{ textDecoration: 'none' }}>+91 9971979794</Link><br />
                <img className="flags" src={american} alt="" /> <Link to="tel:+18445903512" className="mb-0 text-secondary" style={{ textDecoration: 'none' }}>+1-844-590-3512</Link><br />
                <img className="flags" src={aus} alt="" /> <Link to="tel: +1800-040-956" className="mb-0 text-secondary" style={{ textDecoration: 'none' }}>+1800-040-956</Link><br />
                <img className="flags" src={aus} alt="" /> <Link to="tel: 02-8311-0360" className="mb-0 text-secondary" style={{ textDecoration: 'none' }}>02-8311-0360</Link>
              </div>
              <div className="text-center">
                <i className="fa fa-envelope-open fa-3x mb-3" style={{ color: 'rgb(15, 195, 250)' }}></i>
                <h4 className="text-dark">Email</h4>
                <Link to="mailto:support@jdtechnicalsolution.com" className="mb-0 text-secondary" style={{ textDecoration: 'none' }}>support@jdtechnicalsolution.com</Link>
              </div>
            </div>
          </div>

          {/* Form Section */}
          <div className="col-lg-8">
            <h3 className="mb-2">We listen to the voice of every customer.</h3>
            <p className="mb-4">Please email us using the form below if you require any assistance or have any questions:</p>
            <form>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input type="text" className="form-control border-0" id="name" placeholder="Your Name"
                      value={name} onChange={(e) => setName(e.target.value)} />
                    <label htmlFor="name">Your Name</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input type="email" className="form-control border-0" id="email" placeholder="Your Email"
                      value={email} onChange={(e) => setEmail(e.target.value)} />
                    <label htmlFor="email">Your Email</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <input type="text" className="form-control border-0" id="subject" placeholder="Phone"
                      value={phone} onChange={(e) => setPhone(e.target.value)} />
                    <label htmlFor="subject">Phone Number</label>
                  </div>
                </div>
                
                {/* Call Time Dropdown */}
                <div className="col-12">
                  <div className="form-floating">
                    <select
                      className="form-select border-0"
                      id="callTime"
                      value={callTime}
                      onChange={(e) => setCallTime(e.target.value)}
                    >
                      <option value="" disabled>Schedule Callback</option>
                      <option value="9am to 11am">9am to 11am</option>
                      <option value="11am to 1pm">11am to 1pm</option>
                      <option value="1pm to 3pm">1pm to 3pm</option>
                      <option value="3pm to 5pm">3pm to 5pm</option>
                    </select>
                    {/* <label htmlFor="callTime">Best Time for Callback</label> */}
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating">
                    <textarea className="form-control border-0" placeholder="Leave a message here" id="message" style={{ height: "160px" }}
                      value={description} onChange={(e) => setDescription(e.target.value)} />
                    <label htmlFor="message">Brief description of your business...</label>
                  </div>
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={submitHandler}
                    disabled={isSubmitting}
                  >
                    <p className='py-3 mb-0'>
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </p>
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* Maps */}
          <div className="col-12 mt-5">
            <iframe className="rounded w-100"
              style={{ height: "450px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.798139960628!2d-112.2251754!3d33.4769282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b15685e6918fd%3A0x9f863dec39208b33!2s7611%20W%20Thomas%20Rd%2C%20Phoenix%2C%20AZ%2085033%2C%20USA!5e0!3m2!1sen!2s!4v1620264744231!5m2!1sen!2s"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Map USA"
            />
          </div>
          <div className="col-12 mt-5">
            <iframe
              className="rounded w-100"
              style={{ height: "450px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.2703300439184!2d151.20562051520977!3d-33.866230280652135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ae404dcfffff%3A0xbd4ad5e58cb2a887!2sLevel%2013%2C%20Suite%201302%2F109%20Pitt%20St%2C%20Sydney%20NSW%202000%2C%20Australia!5e0!3m2!1sen!2sin!4v1717741234567!5m2!1sen!2sin"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Map Australia"
            />
          </div>
          <div className="col-12 mt-5">
            <iframe className="rounded w-100"
              style={{ height: "450px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.080717244277!2d77.0747779!3d28.6391439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3d39cfaf17d%3A0x7bfa7b4c749eb83e!2sRajiv%20Chowk!5e0!3m2!1sen!2sin!4v1649711464079!5m2!1sen!2sin"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Map India"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
